var _rect, _circle, _text, _text2, _text3, _circle2, _text4, _text5, _text6, _circle3, _text7, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreProductFilmOverviewEvidenceRail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 830,
    height: 116,
    viewBox: "0 0 830 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore product film evidence rail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 828,
    height: 114,
    rx: 22,
    fill: "#07152A",
    fillOpacity: 0.95,
    stroke: "#5B7698",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 58,
    r: 22,
    fill: "#0B2B50",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 63,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "01")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 55,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "DRIVER VERIFIED")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 75,
    fill: "#9CB0C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Identity evidence connected")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 58,
    r: 22,
    fill: "#2B1020",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 321,
    y: 63,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "02")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 356,
    y: 55,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "VEHICLE LINKED")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 356,
    y: 75,
    fill: "#9CB0C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Registration and reading matched")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 58,
    r: 22,
    fill: "#0B2B50",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 589,
    y: 63,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 55,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "FUEL EVENT RECORDED")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 624,
    y: 75,
    fill: "#9CB0C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Litres linked to the event")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreProductFilmOverviewEvidenceRail);
export default __webpack_public_path__ + "static/media/fleetcore-product-film-overview-evidence-rail.42e20f48ed8b6576695bddc9db2c81ed.svg";
export { ForwardRef as ReactComponent };